// extracted by mini-css-extract-plugin
export default {"pageSection":"PageSection_pageSection__MWOz1","practiceDetails":"PageSection_practiceDetails__tXYTb","addPatientList":"PageSection_addPatientList__NAGtm"};